module.exports = __webpack_public_path__ + "img/h5img30.4d035b8c.png";